import { render } from "./CustomPassword.vue?vue&type=template&id=2613d8fe&scoped=true"
import script from "./CustomPassword.vue?vue&type=script&lang=js"
export * from "./CustomPassword.vue?vue&type=script&lang=js"

import "./CustomPassword.vue?vue&type=style&index=0&id=2613d8fe&scoped=true&lang=less"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2613d8fe"]])

export default __exports__